import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, ArrowRightIcon } from './Icons';
import { APP_CONFIG } from '../data/content';

const CTASection = () => {
  return (
    <section id="cta" className="py-20 md:py-28 relative">
      <div className="max-w-5xl mx-auto px-6 sm:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="relative rounded-3xl p-10 sm:p-14 glass-panel border border-brand-500/30 overflow-hidden text-center shadow-2xl specular-border"
        >
          {/* Subtle Ambient Glow */}
          <div className="absolute inset-0 bg-gradient-to-tr from-brand-600/15 via-indigo-600/10 to-accent-500/15 pointer-events-none" />

          <div className="relative z-10 max-w-2xl mx-auto space-y-6">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-brand-500/10 text-brand-600 dark:text-brand-300 border border-brand-500/20 font-inter">
              <SparklesIcon className="w-3.5 h-3.5" />
              <span>Ready for Autonomous Action?</span>
            </div>

            <h2 className="text-3xl sm:text-5xl font-extrabold text-slate-900 dark:text-white font-outfit tracking-tight leading-tight">
              Deploy Multi-Agent Workflows that Deliver Verifiable ROI
            </h2>

            <p className="text-slate-600 dark:text-slate-300 text-base sm:text-lg font-light leading-relaxed">
              Stop building conversational toys. Empower your operations with autonomous planning, real tool executions, and zero-trust multi-tenancy.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
              <a
                href={APP_CONFIG.studioUrl}
                className="w-full sm:w-auto px-8 py-3.5 rounded-xl font-semibold text-sm text-white bg-gradient-to-r from-brand-600 to-indigo-600 hover:from-brand-500 hover:to-indigo-500 shadow-lg shadow-brand-500/30 active:scale-[0.98] transition-all flex items-center justify-center gap-2"
              >
                <span>Launch Cortex Studio</span>
                <ArrowRightIcon className="w-4 h-4" />
              </a>
              <button
                onClick={() => {
                  const el = document.getElementById('simulator');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 rounded-xl font-semibold text-sm text-slate-800 dark:text-slate-200 glass-panel hover:bg-slate-100 dark:hover:bg-slate-800 active:scale-[0.98] transition-all"
              >
                Launch DAG Simulator
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
